// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSeasonStartBody = {
  poolId: string;
  seasonYear: number;
  seasonTitle: string;
};

export type typeSeasonStartOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { seasonId: string };
};

export type typeSeasonStartOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSeasonStartOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSeasonStartOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSeasonStartBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    seasonYear: { type: "integer" },
    seasonTitle: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "seasonYear", "seasonTitle"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSeasonStart(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSeasonStartBody);
  }

  return async function postSeasonStart(
    payload: typeSeasonStartBody,
  ): Promise<typeSeasonStartOutput200 | typeSeasonStartOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSeasonStart" failed before calling the network. #d73e3a333752`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#d73e3a333752" },
        },
        data: null,
      } as typeSeasonStartOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/season/start`,
      httpMethod: "POST",
      options,
    })) as typeSeasonStartOutput200 | typeSeasonStartOutput400;
  };
}
